import React from 'react';

interface errorPageDataType {
  showHeader?: boolean;
}

export const errorMapping: { [key: string]: errorPageDataType } = {
  '404-NotBranded': {
    showHeader: false,
  },
  default: {
    showHeader: true,
  },
};
